import React from 'react';

/** Vérifie si la feature palettes consignées est activée pour le client courant. */
export function isConsignmentPackagingEnabled(features) {
  return features?.CONSIGNMENT_PACKAGING?.enabled === true;
}

/** Classes CSS pour surligner un solde négatif (décision E). */
export const CONSIGNMENT_NEGATIVE_STOCK_CLASS =
  'tw-text-amber-800 tw-bg-amber-100 tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium';

/**
 * Formate un solde avec surlignage warning si négatif.
 * @param {number|null|undefined} stock
 * @returns {React.ReactNode|string}
 */
export function formatConsignmentStockValue(stock) {
  if (stock === null || stock === undefined) {
    return '-';
  }
  if (stock < 0) {
    return (
      <span
        className={`tw-font-bold ${CONSIGNMENT_NEGATIVE_STOCK_CLASS}`}
        title="Solde négatif — anomalie à réconcilier"
      >
        {stock}
      </span>
    );
  }
  return <span className="tw-font-bold">{stock}</span>;
}

/** Libellé d'affichage pour le sens d'un mouvement (avec signe). */
export const CONSIGNMENT_DIRECTION_LABEL = {
  LIVRAISON: '+ Livraison',
  REPRISE: '- Reprise',
  AJUSTEMENT: 'Ajustement manuel',
};

/** Sens d'un ajustement manuel saisi au back-office. */
export const CONSIGNMENT_ADJUSTMENT_DIRECTION = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
};

/** Longueur maximale du motif d'un ajustement (colonne consignment_movement.comment). */
export const CONSIGNMENT_ADJUSTMENT_COMMENT_MAX_LENGTH = 500;

/** Vrai si le mouvement est un ajustement manuel (FLEETC-3277). */
export function isConsignmentAdjustment(movement) {
  return movement?.direction === 'AJUSTEMENT';
}

/**
 * Quantité signée selon le sens du mouvement.
 * Un ajustement porte déjà son signe (positive = ajout, négative = retrait).
 */
export function formatConsignmentMovementQuantity(direction, quantity) {
  if (direction === 'AJUSTEMENT') {
    return quantity > 0 ? `+${quantity}` : `${quantity}`;
  }
  const prefix = direction === 'REPRISE' ? '-' : '+';
  return `${prefix}${quantity}`;
}

/** Affiche tournée et étape source d'un mouvement. */
export function formatConsignmentTourStep(movement) {
  if (!movement?.tour_id && !movement?.tour_number) {
    return '-';
  }

  const tourLabel = movement.tour_number || `Tournée #${movement.tour_id}`;

  if (!movement?.step_id && !movement?.step_name) {
    return tourLabel;
  }

  const stepLabel =
    movement.step_name ||
    (movement.step_order != null
      ? `Étape ${movement.step_order}`
      : `Étape #${movement.step_id}`);

  return `${tourLabel} / ${stepLabel}`;
}
